import { ONBOARDING_VIDEO_ID } from '@components/SideNav2/constants';
import { useSideNav } from '@components/SideNav2/context';
import { Box, Button, Text } from '@mantine/core';

import { footerLinksContainer } from './styles.css';

export function FooterLinks() {
  const { isExpanded } = useSideNav();

  if (!isExpanded) {
    return null;
  }

  return (
    <Box
      style={{
        marginTop: 'auto',
        display: 'flex',
        flexDirection: 'column',
        gap: 'var(--mantine-spacing-sm)',
      }}
      px="sm"
      py="sm"
      className={footerLinksContainer}
    >
      <Button
        component="a"
        size="compact-md"
        variant="outline"
        href={`https://www.youtube.com/watch?v=${ONBOARDING_VIDEO_ID}`}
        target="_blank"
        rel="noreferrer"
      >
        <Text size="sm" fw={600}>
          View tutorial video
        </Text>
      </Button>
    </Box>
  );
}
